const map = {
  pt: 'Portugês - BR',
  en: 'English - US',
  es: 'Espanhol - ES',
}

export default str => map[str] || str
